import { ILinkingServiceStrategy } from 'affiny-core/services/linking/linking';
import queryString from 'query-string';

export const SESSION_ORIGIN = 'session_origin';

export class LinkingWebStrategy implements ILinkingServiceStrategy {
  public getSessionOrigin() {
    const query = window.location.search;
    const sessionOrigin = queryString.parse(query).session_origin;

    if (typeof sessionOrigin === 'string') return sessionOrigin;

    return null;
  }
  public getRefreshToken() {
    const query = window.location.search;
    const refreshToken = queryString.parse(query).debug_remenc;

    if (typeof refreshToken === 'string') return refreshToken;

    return null;
  }
}
